export class Project
{
    ProjectId: number;
    WorkspaceId: number;
    Created: Date;
    Modified?: Date;
    LastActivity?: Date;
    Name: string;
    Description: string;
    IsBuilded: boolean;
}

export class ProjectUser
{
    ProjectUserId: number;
    Created: Date;
    Updated?: Date;
    Name: string;
    Email: string;
    AccessToken: string;
    EvaluationModelId: number;
    ProjectId: number;
    LocalId: string;
    Tags: string[];
}

export class ProjectTemplateLink
{
    ProjectTemplateLinkId: number;
    ProjectId: number;
    Created: Date
    Modified: Date
    Name: string;
    AccessKey: string;
    Views: number
    Downloads: number;
}